var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5CC85C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.25 18.083-2.667-1.166a.664.664 0 0 0-.666.083l-1.084.75a1.25 1.25 0 0 1-1.083.083 38.986 38.986 0 0 1-3.667-3.75.999.999 0 0 1 .084-1.083l.75-1a.752.752 0 0 0 .083-.75l-1.25-2.583a.748.748 0 0 0-.75-.5H9.833a2.833 2.833 0 0 0-1.583 2.666c0 3 2.5 5.75 3.667 6.917 1.166 1.167 3.916 3.75 7.083 3.75 0 0 2 .167 2.667-1.5 0-.083.083-.167.083-.333v-.834a1.086 1.086 0 0 0-.5-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 29.917 2.583-8.167A14.335 14.335 0 0 1 .75 14.583 14.583 14.583 0 1 1 8.083 27.25L0 29.917zm8.417-5.5L9 24.75a11.916 11.916 0 0 0 6.25 1.833 12 12 0 1 0-11.917-12 11.416 11.416 0 0 0 1.834 6.334l.25.5L4 25.833l4.417-1.416z"
  }))));
};
export default SvgWhatsapp;